import React from "react";
import "./CourseCard.css";
import filledheart from "../../assets/new-education/course_filled_heart.svg";
import unfilledheart from "../../assets/new-education/course_unfilled_heart.svg";
import placeholderIcon from "../../assets/new-education/Cert_tick_Icon_8_.svg";
import upcomingLabel from "../../assets/new-education/upcoming_label.svg";

const CourseCard = ({
  course,
  myCourses = [],
  onCourseClick,
  onFavoriteToggle,
  basic = false,
}) => {
  // Get course status from myCourses data
  const getCourseStatus = (courseId) => {
    const enrolledCourse = myCourses.find(
      (myCourse) => myCourse.course === courseId || myCourse.id === courseId
    );
    return {
      isEnrolled: !!enrolledCourse,
      isFavorite: enrolledCourse?.is_favorite || false,
      enrollmentId: enrolledCourse?.id || null,
      progressPercentage: enrolledCourse?.progress_percentage || 0,
    };
  };

  const courseStatus = getCourseStatus(course.id);

  // Determine CSS class based on class_type instead of completion
  const isPhysical = course.class_type === "physical";

  // Determine if course is upcoming
  // You can modify this logic based on your specific requirements
  const isUpcoming =
    course.status === "upcoming" ||
    course.is_upcoming ||
    (course.start_date && new Date(course.start_date) > new Date());

  // Handle card click
  const handleCardClick = () => {
    if (onCourseClick) {
      onCourseClick(course.id);
    }
  };

  // Handle favorite toggle
  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (onFavoriteToggle) {
      onFavoriteToggle(e, course.id);
    }
  };

  return (
    <div
      className={`course-card-new ${isPhysical ? "completed" : "incomplete"}`}
      onClick={handleCardClick}
    >
      <div className="course-card-top">
        {/* Heart icon */}
        <div className="course-card-heart" onClick={handleFavoriteClick}>
          <img
            src={courseStatus.isFavorite ? filledheart : unfilledheart}
            alt={courseStatus.isFavorite ? "Filled heart" : "Unfilled heart"}
            width={16}
            height={16}
          />
        </div>

        {/* Duration */}
        <div className="course-card-duration">
          {course.duration ? `${course.duration}min` : "26hrs"}
        </div>
      </div>

      {/* Course content */}
      <div className="course-card-content">
        <h3 className="course-card-title">
          {course.name ? course.name : course.course_name}
        </h3>

        {/* Course icon */}
        <div className="course-card-icon">
          <img
            src={course.thumbnail ? course.thumbnail : placeholderIcon}
            alt={course.name}
            className="course-icon-img"
          />
          {/* Upcoming label */}
          {isUpcoming && (
            <div className="upcoming-label">
              <img
                src={upcomingLabel}
                alt="Upcoming"
                className="upcoming-label-img"
              />
            </div>
          )}
        </div>

        {/* Module count */}
        {!basic && (
          <div className="course-card-modules">
            {course.class_count
              ? `${course.completed_class_count}/${course.class_count} moduler`
              : "0/0 moduler"}
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseCard;
